import React, { Component } from 'react';
import { connect } from 'react-redux';
import './styles.scss';
import {
  scrollToSelectedResult,
  getErrorMessages,
  setCalculateGridSelectedNailItem,
  setCalculateNailsFilter
} from '@reducers/selectors/calculate/actions';
import { setNailsSortingMethod } from '@reducers/web-services/calculate/actions';
import { isArray } from 'util';
import { APP_TYPES } from '@config';
import { APP_TEXTS } from '@texts';

const STATUS_LIST = ['icon_uncheck', 'icon_check', 'icon_invalid', 'icon_timeout'];

const ALL = 'ALL';

const RESULTS = {
  [ALL]: [],
  OK: [1],
  NOT_OK: [0, 2],
  TIMEOUT: [3]
};

const Filters = {
  status: 'status',
  nailType: 'nailType',
  product: 'product'
};

class CalculateNailsSelection extends Component {

  _isMounted = false;

  componentDidMount() {
    this._isMounted = true;
    if (this.props.refreshSelectedResult) {
      this.props.scrollToSelectedResult(false);
      this.scrollToSelectedRow();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (this._isMounted) {
      if (this.props.filters.status !== prevProps.filters.status ||
        this.props.filters.nailType !== prevProps.filters.nailType ||
        this.props.filters.product !== prevProps.filters.product) {
        this.selectFirstResult();
      }
      else if (this.props.refreshSelectedResult) {
        this.props.scrollToSelectedResult(false);
        this.scrollToSelectedRow();
      }
      else if (prevProps.isWaiting === true && this.props.isWaiting === false) {
        this.scrollToSelectedRow();
      }
    }
  }

  filteredData = (skipFilter) => {
    return this.props.grid.filter((item) => {
      var { status, nailType, product } = this.props.filters;

      if (skipFilter) {
        switch (skipFilter) {
          case Filters.status: { status = ALL; break; }
          case Filters.nailType: { nailType = ALL; break; }
          case Filters.product: { product = ALL; break; }
          default: break;
        }
      }

      /* eslint-disable eqeqeq */
      return (
        ((!status || status === ALL) || RESULTS[status].indexOf(item.Status) > -1) &&
        ((!nailType || nailType === ALL) || nailType == item.NailType) &&
        ((!product || product === ALL) || product == item.NailProduct)
      );
      /* eslint-enable eqeqeq */
    }).sort(compareBy(this.props.sortBy, this.props.isReverse));

  }

  chooseResult = (value) => {
    this.props.setFilter(Filters.status, value);
  }

  chooseProducts = (value) => {
    this.props.setFilter(Filters.product, value);
  }

  chooseNailType = (value) => {
    this.props.setFilter(Filters.nailType, value);
  }

  clearFilter = () => {
    Object.values(Filters).forEach(filter => {
      this.props.setFilter(filter, ALL);
    });
  }

  selectFirstResult = () => {
    const filteredResults = this.filteredData();
    if (filteredResults && filteredResults.length > 0) {
      this.props.setActive(filteredResults[0]);
    } else {
      this.props.setActive(null);
    }
  }

  scrollToSelectedRow = () => {
    if (this.selectedRow) {
      this.selectedRow.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  getSortingArrow = (field) => {
    if (this.props.sortBy === field) {
      if (this.props.isReverse)
        return "↓";
      else
        return "↑";
    } else {
      return "↕";
    }
  }

  render() {
    return (
      <div className="calculation">
        <section className="list-type calculate-nails-selection">
          <section className="d-flex filters-section">
            <div className="filters d-flex flex-wrap">
              <select name="results" value={this.props.filters.status} onChange={e => this.chooseResult(e.target.value)}>
                <option value={ALL}>{APP_TEXTS.ANCHOR_SELECTION_ALL_RESULTS.Content}</option>
                {this.filteredData(Filters.status).some((res) => RESULTS.OK.indexOf(res.Status) > -1) && (
                  <option value="OK">{APP_TEXTS.ANCHOR_SELECTION_OK.Content}</option>
                )}
                {this.filteredData(Filters.status).some((res) => RESULTS.NOT_OK.indexOf(res.Status) > -1) && (
                  <option value="NOT_OK">{APP_TEXTS.ANCHOR_SELECTION_NOT_OK.Content}</option>
                )}
                {this.filteredData(Filters.status).some((res) => RESULTS.TIMEOUT.indexOf(res.Status) > -1) && (
                  <option value="TIMEOUT">{APP_TEXTS.ANCHOR_SELECTION_TIMEOUT.Content}</option>
                )}
              </select>

              <select name="products" value={this.props.filters.product} onChange={e => this.chooseProducts(e.target.value)}>
                <option value={ALL}>{APP_TEXTS.ANCHOR_SELECTION_ALL_PRODUCTS.Content}</option>
                {Object.keys(this.props.filterOptions.products).sort((a, b) => a.localeCompare(b))
                  .map(product =>
                    this.filteredData(Filters.product).some(res => res.NailProduct === product) && (
                      <option value={product} key={product}>{product}</option>
                    ))}
              </select>

              <select name="nailType" value={this.props.filters.nailType} onChange={e => this.chooseNailType(e.target.value)}>
                <option value={ALL}>All types</option>
                {Object.keys(this.props.filterOptions.nailType).sort((a, b) => a.localeCompare(b))
                  .map(type =>
                    this.filteredData(Filters.nailType).some(res => res.NailType === type) && (
                      <option value={type} key={type}>{type}</option>
                    ))}
              </select>

              <button onClick={this.clearFilter}>{APP_TEXTS.ANCHOR_SELECTION_BUTTON_REMOVE_FILTERS.Content}</button>
            </div>
          </section>

          <table className="fixed_headers calculate-anchor-selection__table">
            <thead className="thead">
              <tr>
                <th onClick={() => this.props.setSortBy('Status')}>
                  {APP_TEXTS.ANCHOR_SELECTION_OK.Content} {this.getSortingArrow('Status')}
                </th>
                <th onClick={() => this.props.setSortBy('NailProduct')}>
                  {APP_TEXTS.ANCHOR_SELECTION_PRODUCT.Content} {this.getSortingArrow('NailProduct')}
                </th>
                <th onClick={() => this.props.setSortBy('NailType')}>
                  {APP_TEXTS.TYPE_LABEL.Content} {this.getSortingArrow('NailType')}
                </th>
                <th onClick={() => this.props.setSortBy('Interaction')}>
                  {APP_TEXTS.CALCULATE_NAILS_INTERACTION.Content} {this.getSortingArrow('Interaction')}
                </th>
              </tr>
            </thead>

            <tbody className="tbody">
              {this.filteredData().map(item => (
                <ConnectedRow
                  key={JSON.stringify(item)}
                  item={item}
                  onClick={() => this.props.setActive(item)}
                  activeItem={this.props.selectedItem}
                  owner={this}
                />
              ))}
            </tbody>
          </table>
        </section>
      </div>
    );
  }

}

export function compareBy(key, isReverse) {
  return function (a, b) {
    var reverseOrder = isReverse;
    // Special cases:
    if (key === 'Interaction') {
      const maximumBetaA = 1;
      const maximumBetaB = 1;
      if (a[key] <= 0 && b[key] > maximumBetaB) return 1; //(isReverse ? -1 : 1);  beta has priority over ***
      else if (b[key] <= 0 && a[key] > maximumBetaA) return -1; //(isReverse ? 1 : -1);  beta has priority over ***
      //(isReverse ? -1 : 1);  beta under 100% has priority
      // beta under maximum has priority only if the anchor is suitable (e.g. overall beta < 1.2 but tensile beta > 1)
      else if ((a[key] <= 0 || a[key] > maximumBetaA || a['Status'] === 0) && (b[key] > 0 && b[key] <= maximumBetaB && b['Status'] === 1))
        return 1;
      else if ((b[key] <= 0 || b[key] > maximumBetaB || b['Status'] === 0) && (a[key] > 0 && a[key] <= maximumBetaA && a['Status'] === 1))
        return -1;
      // reverse not suitable anchors so that the top not suitable anchor has the lowest beta when sorting by descending beta
      else if (a['Status'] === 0 && b['Status'] === 0)
        reverseOrder = !reverseOrder;
      // else follow the normal cases
    }
    else if (key === 'Status') { // (0 - anchor not suitable, 1 - anchor suitable, 2 - anchor not calculated) 
      if (a[key] === 2) return 1;//(isReverse ? -1 : 1);
      else if (b[key] === 2) return -1;//(isReverse ? 1 : -1);
      // else reverse the normal cases since 0 = not suitable && 1 = suitable
      else
        reverseOrder = !reverseOrder;
    }

    // Normal cases:
    if (reverseOrder) {
      if (a[key] < b[key]) return 1;
      if (a[key] > b[key]) return -1;
    } else {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
    }

    return 0;
  };
}

function Row({ item, onClick, activeItem, owner }) {
  return (
    <tr onClick={onClick}
      className={`${JSON.stringify(activeItem) === JSON.stringify(item) && 'active'}`}
      ref={JSON.stringify(activeItem) === JSON.stringify(item) ? (ref) => { owner.selectedRow = ref; } : null}>
      <td className="text-center">
        <span className={STATUS_LIST[item.Status || 0]} />
      </td>
      <td>
        {item.NailProduct}
      </td>
      <td>
        {item.NailType}
      </td>
      <td className="text-center">
        {item.Interaction === 0 ? '***' : `${(item.Interaction * 100).toFixed(2)}%`}
      </td>
    </tr>
  );
}

const ConnectedRow = connect()(Row);

const mapState = state => ({
  grid: state.main.appType === APP_TYPES.WOOD_CONNECTION
    ? (state.webServices.calculate.grid &&
      state.webServices.calculate.grid.NailsDesignResults &&
      isArray(state.webServices.calculate.grid.NailsDesignResults)
      ? state.webServices.calculate.grid.NailsDesignResults
      : [])
    : (isArray(state.webServices.calculate.grid)
      ? state.webServices.calculate.grid
      : []),
  filterOptions: (() => {
    const filterOptions = {
      nailType: {},
      products: {}
    };

    const gridData = state.webServices.calculate.grid &&
      state.webServices.calculate.grid.NailsDesignResults;

    if (gridData && isArray(gridData)) {
      gridData.forEach(i => {
        filterOptions.nailType[i.NailType] = i.NailType;
        filterOptions.products[i.NailProduct] = i.NailProduct;
      });
    }

    return filterOptions;
  })(),
  selectedItem: state.selectors.calculate[state.main.appType] &&
    state.selectors.calculate[state.main.appType].gridSelectedNailItem,
  appType: state.main.appType,
  sortBy: state.webServices.calculate.nails.sortBy,
  isReverse: state.webServices.calculate.nails.isReverse,
  isWaiting: state.webServices.calculate.isWaiting,
  refreshSelectedResult: state.selectors.calculate[state.main.appType] &&
    state.selectors.calculate[state.main.appType].scrollToSelectedResult || false,
  filters: state.selectors.calculate[state.main.appType] &&
    state.selectors.calculate[state.main.appType].nailFilters || {
    [Filters.nailType]: ALL,
    [Filters.product]: ALL,
    [Filters.status]: ALL
  }
});

const mapDispatch = dispatch => ({
  setActive: value => dispatch(setCalculateGridSelectedNailItem(value)),
  setSortBy: value => dispatch(setNailsSortingMethod(value, null)),
  scrollToSelectedResult: value => dispatch(scrollToSelectedResult(value)),
  setFilter: (type, value) => dispatch(setCalculateNailsFilter(type, value)),
  getErrorMessages: (value) => dispatch(getErrorMessages(value))
});

export default connect(mapState, mapDispatch)(CalculateNailsSelection); 



// WEBPACK FOOTER //
// ./src/views/Calculate/components/CalculateNailsSelection/index.js